import React, { useState } from "react";
import {
  LinearProgress,
  OutlinedInput,
} from "@material-ui/core";
import VisibilityIcon from '@material-ui/icons/Visibility';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  useRouteMatch
} from "react-router-dom";
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,
  TableBody,
  TableCell, Checkbox, IconButton
} from "@material-ui/core";
// import Checkbox from '@material-ui/Checkbox';
import schooleRegistration from "./Locality/Service/schooleRegistration"
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import { Grid, Card, Box, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';

import { useContext, useEffect } from 'react';
import { useTheme } from "@material-ui/styles";

import {
  ResponsiveContainer,
  ComposedChart,
  AreaChart,
  LineChart,
  Line,
  Area,
  PieChart,
  Pie,
  Cell,
  YAxis,
  XAxis,
} from "recharts";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// styles
import useStyles from "./styles";

// components
import mock from "./mock";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import BigStat from "./components/BigStat/BigStat";
import { withStyles } from '@material-ui/core/styles';
import SchooleRegistrationService from "./Locality/Service/schooleRegistration";
export default function SchooleRegistration(props) {
  const classes = useStyles();
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [otp, setOtp] = useState('');
  const [id, setId] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  
  const [schooleRegistrationList, setSchooleRegistrationList] = useState([]);
  const [schooleRegistration, setSchooleRegistration] = useState({
    schooleName: '',
    branch: 'single',
    parentSchoolId: props.parentSchoolId || null,
    address: '',
    city: '',
    pincode: '',
    selectCountry: '',
    name: '',
    email: '',
    mobileNumber: '',
    schooleEmail: '',
    schooleContact: '',
    password: '',
    subscription: '',
    terms: false,
    logo: '',
  
  });

  const isBranchMode = !!props.parentSchoolId;

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleLogoFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size should be less than 5MB');
        return;
      }
      setLogoFile(file);
      
      // Create preview URL immediately
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoUrl(reader.result);
      };
      reader.readAsDataURL(file);

      // Auto-upload the logo
      setUploadingLogo(true);
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageName', file.name);

      try {
        const res = await SchooleRegistrationService.uploadImage(formData);
        setLogoUrl(res.url);
        setSchooleRegistration(prev => ({ ...prev, logo: res.url }));
        // Update formik values
        formik.setFieldValue('logo', res.url);
        setUploadingLogo(false);
      } catch (err) {
        console.error('Error uploading logo:', err);
        alert(err.response?.data?.message || 'Error uploading logo');
        setUploadingLogo(false);
        // Reset on error
        setLogoFile(null);
        setLogoUrl('');
        const fileInput = e.target;
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoUrl('');
    setSchooleRegistration(prev => ({ ...prev, logo: '' }));
    formik.setFieldValue('logo', '');
    // Reset file input
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const validationSchema = Yup.object().shape({
    schooleName: Yup.string().required('schoole Name  is required'),
    branch: Yup.string().oneOf(['single', 'multiple']),
    parentSchoolId: Yup.string().nullable(),
    // address made optional
    address: Yup.string(),
    city: Yup.string().required('city is required'),
    // pincode made optional (no format validation)
    pincode: Yup.string(),
    selectCountry: Yup.string().required('selectCountry is required'),
    name: Yup.string().required('name is required'),
    email: Yup.string(),
    mobileNumber: Yup.string().required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits'),
    // schooleEmail made optional
    schooleEmail: Yup.string(),
    // schooleContact made optional (no format validation)
    schooleContact: Yup.string(),
    password: Yup.string().required('password is required'),
    // In branch mode, subscription is optional and hidden
    subscription: isBranchMode
      ? Yup.string().oneOf(['yes', 'no', ''])
      : Yup.string()
          .required('Please select trial subscription option')
          .oneOf(['yes', 'no'], 'Please select either Yes or No for trial subscription'),
    // In branch mode, terms checkbox is not shown and not required
    terms: isBranchMode
      ? Yup.boolean()
      : Yup.boolean()
          .required('You must agree to the Terms and Privacy Policy')
          .oneOf([true], 'You must agree to the Terms and Privacy Policy'),
  });
  const handleOtpSubmit = () => {
    const values = formik.values;
    // values.otpId=id
    // values.otp=otp
    SchooleRegistrationService.creteSchooleRegistration(values).then((res) => {
 
      alert(" Registration Successfully.");
      props.history.push('/montessori/login');
     
    })
   .catch((error) => {
    alert(error.message);
     console.error('Error generating OTP:', error);
   });
    // setOtpDialogOpen(false);
  };
  const getSchooleRegistrationList = () => {
    SchooleRegistrationService.getAllSchooleRegistration().then((res) => {
      setSchooleRegistrationList(res);
    }).catch((err) => {
      setError(err.message);
    });
  }


  const formik = useFormik({
    initialValues:  schooleRegistration,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      // Clear previous errors
      setSubmitError(null);
      
      // Include logo URL in submission
      const submitData = {
        ...values,
        logo: logoUrl || values.logo,
        // Convert terms boolean to string for backend
        terms: values.terms ? 'accepted' : ''
      };
      
      // Remove empty email field to avoid duplicate key error
      if (!submitData.email || submitData.email.trim() === '') {
        delete submitData.email;
      }
      
      SchooleRegistrationService.creteSchooleRegistration(submitData).then((res) => {
        alert(" Registration Successfully.");
        props.history.push('/montessori/login');
      })
      
      // SchooleRegistrationService.otpGerate({mobile:values.mobileNumber})
      // .then((res) => {
      //   setId(res.id);
      //   setOtpDialogOpen(true);
      // })
   
        .catch((err) => {
          // Extract error message from response
          let errorMessage = 'Registration failed. Please try again.';
          
          if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
          } else if (err.response?.data?.error) {
            errorMessage = err.response.data.error;
          } else if (err.message) {
            errorMessage = err.message;
          }
          
          // Handle MongoDB duplicate key error
          if (errorMessage.includes('E11000') || errorMessage.includes('duplicate key')) {
            if (errorMessage.includes('email')) {
              errorMessage = 'This email address is already registered. Please use a different email or leave it empty.';
            } else if (errorMessage.includes('mobileNumber')) {
              errorMessage = 'This mobile number is already registered. Please use a different mobile number.';
            } else {
              errorMessage = 'A record with this information already exists. Please check your details and try again.';
            }
          }
          
          setSubmitError(errorMessage);
        })
    },
  });


  return (

    <>
      <Card style={{ maxWidth: 1200, margin: '0 auto', padding: 16 }}>
        <Box>
          <div>
            {/* <form onSubmit={formik.handleSubmit} > */}
              <Grid container spacing={2} >
                {isBranchMode && (
                  <Grid item xs={12}>
                    <IconButton
                      onClick={() => {
                        if (props.onBack) {
                          props.onBack();
                        } else if (props.history && props.history.goBack) {
                          props.history.goBack();
                        } else {
                          window.history.back();
                        }
                      }}
                      style={{
                        backgroundColor: '#0f3b62',
                        color: '#fff',
                        marginBottom: 8,
                      }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <PageTitle InputProps={{ style: { color: '#10b680' } }} title=" School Registration" ></PageTitle>
                </Grid>
                {submitError && (
                  <Grid item xs={12}>
                    <div style={{
                      padding: '12px 16px',
                      backgroundColor: '#ffebee',
                      border: '1px solid #f44336',
                      borderRadius: '4px',
                      color: '#c62828',
                      marginTop: '10px',
                      marginBottom: '10px',
                      fontSize: '14px'
                    }}>
                      <strong>Error:</strong> {submitError}
                    </div>
                  </Grid>
                )}
                {!isBranchMode && (
                  <>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                      <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }}>School Logo:</span>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleLogoFileChange}
                        disabled={uploadingLogo}
                        style={{ marginBottom: '10px' }}
                      />
                      {uploadingLogo && (
                        <div style={{ marginTop: '10px', color: 'rgb(15 59 98)' }}>
                          Uploading logo...
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      {logoUrl && (
                        <div style={{ marginTop: '10px', position: 'relative', display: 'inline-block' }}>
                          <img
                            src={logoUrl}
                            alt="School Logo Preview"
                            style={{
                              maxWidth: '200px',
                              maxHeight: '200px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              padding: '5px'
                            }}
                          />
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleLogoRemove}
                            style={{
                              position: 'absolute',
                              top: '5px',
                              right: '5px',
                              minWidth: 'auto',
                              padding: '4px 8px',
                              backgroundColor: '#f44336',
                              color: 'white',
                              fontSize: '12px'
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                      )}
                    </Grid>
                  </>
                )}
         
                <Grid item xs={12} sm={12} md={6}>
                  <TextField 
                    fullWidth
                    autoFocus
                    margin="dense"
                    id="schooleName"
                    name="schooleName"
                    label="Name Of The School"
                    type="text"
                    variant="outlined"
                    value={formik.values.schooleName}
                    onChange={formik.handleChange}
                    error={formik.touched.schooleName && Boolean(formik.errors.schooleName)}
                    helperText={formik.touched.schooleName && formik.errors.schooleName}
                  />
                </Grid>
                {!isBranchMode && (
                  <Grid item xs={12} sm={12} md={6}>
                    <FormControl fullWidth margin="dense" variant="outlined">
                      <InputLabel id="branch-label">Branch</InputLabel>
                      <Select
                        labelId="branch-label"
                        id="branch"
                        name="branch"
                        label="Branch"
                        value={formik.values.branch}
                        onChange={formik.handleChange}
                      >
                        <MenuItem value="single">Single</MenuItem>
                        <MenuItem value="multiple">Multiple</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12} style={{ marginTop: '30px' }}>
                  <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }} >Address:</span>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="address"
                    name="address"
                    placeholder="Street, Area / Landmark"
                    label="Address"
                    type="text"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth           
                    margin="dense"
                    id="city"
                    name="city"
                    label="City "
                    type="text"
                    variant="outlined"
                    value={formik.values.city}
                    
                    onChange={formik.handleChange}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    margin="dense"
                    id="pincode"
                    name="pincode"
                    label="Pin Code"
                    type="text"
                    variant="outlined"
                    value={formik.values.pincode}
                    
                    onChange={formik.handleChange}
                    error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                    helperText={formik.touched.pincode && formik.errors.pincode}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} >
                  <FormControl fullWidth margin="dense" variant="outlined">
                    <InputLabel id="demo-simple-select-label">Select country</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="selectCountry"
                      name="selectCountry"

                      label="Select country"
                      onChange={formik.handleChange}
                      value={formik.values.selectCountry}
                      error={formik.touched.selectCountry && Boolean(formik.errors.selectCountry)}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={1}>United States</MenuItem>
                      <MenuItem value={2}>United Kingdom</MenuItem>
                      <MenuItem value={3}>Australia</MenuItem>
                      <MenuItem value={4}>India</MenuItem>
                      <MenuItem value={5}>Finland</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '30px' }}>
                  <span style={{ fontSize: '20px', color: 'rgb(15 59 98)', fontWeight:"600" }} >Contact Details:</span>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="name"
                    name="name"
                    label="Full Name"
                    type="Full Name"
                    variant="outlined"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="email"
                    name="email"
                    label="Email ID"
                    type="Email ID"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="mobileNumber"
                    name="mobileNumber"
                    label="Mobile Number (login)"
                    type="Mobile Number"
                    variant="outlined"
                    value={formik.values.mobileNumber}
                    onChange={formik.handleChange}
                    error={formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)}
                    helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="schooleEmail"
                    name="schooleEmail"
                    label="School Email "
                    type="Schoole Email"
                    variant="outlined"
                    value={formik.values.schooleEmail}
                    onChange={formik.handleChange}
                    error={formik.touched.schooleEmail && Boolean(formik.errors.schooleEmail)}
                    helperText={formik.touched.schooleEmail && formik.errors.schooleEmail}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    fullWidth
                    
                    margin="dense"
                    id="schooleContact  "
                    name="schooleContact"
                    label="School contact number   "
                    type="Schoole contact number "
                    variant="outlined"
                    value={formik.values.schooleContact}

                    onChange={formik.handleChange}
                    error={formik.touched.schooleContact && Boolean(formik.errors.schooleContact)}
                    helperText={formik.touched.schooleContact && formik.errors.schooleContact}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6}>

                  <TextField
                    id="password"
                    fullWidth
                    margin="normal"
                    label=" Set Password  "
                    variant="outlined"
                    // placeholder="Password"
                    type="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                </Grid>
                {!isBranchMode && (
                  <>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl 
                        component="fieldset" 
                        error={formik.touched.subscription && Boolean(formik.errors.subscription)}
                        fullWidth
                      >
                        <FormLabel component="legend">Avail trail subscription</FormLabel>
                        <RadioGroup 
                          aria-label="subscription"
                          name="subscription" 
                          id="subscription" 
                          value={formik.values.subscription}
                          onChange={formik.handleChange}
                        >
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                        {formik.touched.subscription && formik.errors.subscription && (
                          <FormHelperText style={{ color: '#f44336', marginLeft: 14 }}>
                            {formik.errors.subscription}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <FormControl 
                        error={formik.touched.terms && Boolean(formik.errors.terms)}
                        fullWidth
                      >
                        <FormControlLabel
                          control={
                            <Checkbox   
                              name="terms"  
                              id="terms" 
                              checked={formik.values.terms}
                              onChange={(e) => formik.setFieldValue('terms', e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <span style={{ color: '#5f6368' }}>
                              By continuing you agree to our 
                              <a href="https://www.montestory.in/#/montessori/term" target="_blank" rel="noopener noreferrer" style={{ color: '#6c63ff', textDecoration: 'underline', marginLeft: 4, marginRight: 4 }}>Terms</a>
                              and
                              <a href="https://www.montestory.in/#/montessori/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#6c63ff', textDecoration: 'underline', marginLeft: 4 }}>Privacy Policy</a>.
                            </span>
                          }
                        />
                        {formik.touched.terms && formik.errors.terms && (
                          <FormHelperText style={{ color: '#f44336', marginLeft: 14 }}>
                            {formik.errors.terms}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </>
                )}
            
              </Grid>
              <div style={{ textAlign: 'right', margin: '29px' }}>
                <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                onClick={ formik.handleSubmit} type="submit" variant="contained" >Submit</Button>
              </div>
              {/* <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
        <DialogTitle>Enter OTP</DialogTitle>
        <DialogContent>
          <TextField
            label="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOtpDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleOtpSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog> */}

            {/* </form> */}
          </div>
        </Box>

      </Card>


    </>
  );
}


